<template>
  <el-table
    v-loading="listLoading"
    :key="0"
    :data="alist"
    border
    fit
    highlight-current-row
    style="width: 100%;min-height:1000px;"
  >
    <el-table-column :label="$t('table.id')" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.id }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('amount.amt')" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.amt }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('amount.amtTypeName')" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.amtTypeName }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('amount.createdTime')" align="center" width="170px">
      <template slot-scope="scope">
        <span>{{ scope.row.createdTime }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('amount.optStationName')" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.optStationName }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('amount.memo')" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.memo }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'Amount',
  props: {
    alist: {
      type: Array,
      required: true,
      twoWay: true,
      default: () => []
    },
    listLoading: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  }
}
</script>

